import { render, staticRenderFns } from "./CalliaWordToPdf.vue?vue&type=template&id=f9353c10&scoped=true"
import script from "./CalliaWordToPdf.vue?vue&type=script&lang=js"
export * from "./CalliaWordToPdf.vue?vue&type=script&lang=js"
import style0 from "./CalliaWordToPdf.vue?vue&type=style&index=0&id=f9353c10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9353c10",
  null
  
)

export default component.exports